import React from 'react';

import {
  Box,
  Grid,
  Stack,
  Button,
  Divider,
  useTheme,
  Typography,
  useMediaQuery,
} from '@mui/material';

import useActionEvent from 'src/hooks/use-action-event';
import { useCustomNavigate } from 'src/hooks/use-custom-navigate';

import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';

import { navigationFooterInfo } from '../minimalFooter/minimalFooter';

export default function Footer() {
  const navigate = useCustomNavigate();
  // const footerButtonsStyle = {
  //   bgcolor: 'transparent',
  //   borderRadius: '100px',
  //   color: '#251E1E',
  //   fontWeight: 500,
  //   border: '1.8px solid #000000',
  //   width: '118px',
  //   height: '42px',
  //   p: '16px',
  //   ':disabled': {
  //     bgcolor: 'transparent',
  //     color: '#251E1E',
  //   },
  //   fontSize: 'clamp(12px, 5vw, 14px)',
  // };

  const theme = useTheme();
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isDown1100 = useMediaQuery('(max-width: 1100px)');
  const isDown920 = useMediaQuery('(max-width: 920px)');

  const { sendActionEvent } = useActionEvent()

  const handleRedirect = () => {
    sendActionEvent(
      'lp_events_download_app_click',
      'click',
      ['cn_firebase', 'roxcode'],
      {
        event_date: new Date().toLocaleString('pt-BR', {
          timeZone: 'America/Sao_Paulo',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        }),
        log_name: 'lp_events_download_app_click'
      }
    )
    window.open('https://cidade-center-norte.web.app/SE9NRV9TQ1JFRU5TL2luaWNpbw==');
  };

  return (
    <>
      <Box bgcolor="#EAEEF5" px={3} pt={7}>
        <Stack direction="column" overflow="hidden" px={isDownLg ? 2 : 9} spacing={4}>
          <Stack direction="row" spacing={5} justifyContent="space-between">
            <Stack direction="column" spacing={3} alignContent="center" justifyContent="center">
              <Box
                justifyContent="center"
                alignItems="center"
                sx={{
                  width: '146px',
                  aspectRatio: '150 / 24',
                  overflow: 'hidden',
                }}
              >
                <Box
                  component="img"
                  src="/logo/footer_logo.png"
                  alt="Ilustração"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
              </Box>
              <Typography
                sx={{ fontWeight: 700 }}
                variant="h5"
                color="primary.main"
                fontWeight={500}
              >
                Suas visitas na Cidade Center Norte geram benefícios.
              </Typography>
            </Stack>
            <Box
              justifyContent="center"
              alignItems="center"
              sx={{
                maxWidth: '371px',
                width: 'clamp(320px, 20vw, 371px)',
                aspectRatio: '371 / 145',
                overflow: 'hidden',
              }}
            >
              <Box
                component="img"
                src="/logo/footer_img.png"
                alt="Ilustração"
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
            </Box>
          </Stack>
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              {!isDown920 && <Iconify icon="ep:download" color="#D22E2D" width={24} height={24} />}
              <Typography color="#D22E2D" variant="h6" fontWeight={700} lineHeight="140%">
                Baixe o app Center Norte, faça parte <br />
                do nosso clube e aproveite.
              </Typography>
            </Stack>
            <Button
              onClick={handleRedirect}
              sx={{
                bgcolor: 'transparent',
                py: 2,
                px: 8,
                width: 'clamp(300px, 100%, 443px)',
                color: '#214983',
                border: '1px solid var(--400-blue, #214983)',
              }}
            >
              Baixe o App
            </Button>
            <Box
              justifyContent="center"
              alignItems="center"
              sx={{
                maxWidth: '300px',
                aspectRatio: '300 / 50',
                width: 'clamp(250px, 20vw, 300px)',
              }}
            >
              <Box
                component="img"
                src="/logo/appstore_google_play.png"
                alt="Ilustração"
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
            </Box>
          </Stack>
        </Stack>
        <Divider color="#21498333" sx={{ opacity: '20%', mt: 7 }} />
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            maxHeight: '100px',
            alignItems: 'flex-end',
            mb: '14px',
            aspectRatio: '538/65',
          }}
        >
          <Logo
            data-testid="logo"
            customLogo="/logo/logo_cidade_center_norte.png"
            sx={{
              height: 32,
              width: 'auto',
              maxWidth: '538px',
              minHeight: '24px',
            }}
          />
        </Box>
        <Grid
          container
          spacing={1.5}
          justifyContent="space-evenly"
          alignItems="center"
          columnGap="40px"
          sx={{
            py: 4,
            px: 2,
            bgcolor: '#EAEEF5',
          }}
        >
          {[
            'lar_center.png',
            'shopping_center_norte.png',
            'expo_center_norte.png',
            'instituto_center_norte.png',
            'center_norte_inc.png',
            'novotel.png',
          ].map((logo, index) => (
            <Grid
              item
              xs={6}
              sm={5}
              md={isDown1100 ? 2 : 1.65}
              key={index}
              display="flex"
              justifyContent="center"
            >
              <Box
                component="img"
                src={`/logo/${logo}`}
                alt={`logo-${index}`}
                sx={{
                  maxHeight: 24,
                  maxWidth: 180,
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      <Grid
        container
        sx={{
          bgcolor: 'mainBanners.bgColor',
          alignContent: 'center',
          justifyContent: 'center',
        }}
      >
        {navigationFooterInfo.map((e, idx) => (
          <Grid item py={3} key={idx}>
            <Button
              sx={{ color: 'mainBanners.textColor', fontWeight: 500, fontSize: '16px', px: 3 }}
              onClick={() => {
                if (e?.type === 'open') {
                  window.open(e?.url);
                } else {
                  navigate(e?.url);
                }
              }}
              startIcon={e?.text === 'Fale conosco' ? <Iconify icon="ic:baseline-whatsapp" /> : undefined}
            >
              {e?.text}
            </Button>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
